import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import _ from "lodash";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import Modal from "../../Components/Modal/Modal";
import AutoCompleteDropdownStatic from "../../Components/Input/AutoCompleteDropdownStatic";
import api from "../../Services/Api/api";
import etcModule from "../../Modules/etc/etc-module";
import config from "../../Config";

const NewFeedbackQuestionForm = ({
  isOpen,
  onClose,
  setScreenState,
  user,
  onSuccess,
  officeCategories,
  officeTypes,
}) => {
  const [step, setStep] = useState(1);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    district: user.district._id,
    officeType: null,
    officeCategory: null,
    question: "",
    responseType: null,
    options: null,
  });

  useEffect(() => {
    if (isOpen) {
      if (!officeCategories || !officeTypes) {
        loadOfficeData();
      }
    }
  }, [isOpen]);

  useEffect(() => {
    if (formData.officeType) {
      const officeType = officeTypes.find((x) => x._id === formData.officeType);
      if (officeType.category !== formData.officeCategory) {
        handleChange("officeType", null);
      }
    }
  }, [formData.officeCategory]);

  const loadOfficeData = async () => {
    try {
      const { officeTypes, officeCategories } = await api.get(
        "v1/appdata/office-data"
      );
      setScreenState({ officeTypes, officeCategories }, false, "APP");
    } catch (e) {
      toast.error("Error loading data: " + e.message);
    }
  };

  // Handle Input Change
  const handleChange = (name, value) =>
    setFormData({ ...formData, [name]: value });

  // Submit Form
  const handleSubmit = async () => {
    try {
      if (loading) return;

      setError(null);
      setLoading(true);

      const { feedbackQuestion } = await api.post(
        "v1/district-admin/feedback-question",
        {
          ..._.pick(formData, [
            "district",
            "officeType",
            "question",
            "responseType",
          ]),
          options:
            formData.responseType === "options"
              ? formData.options
                  ?.split(",")
                  .map((x) => x.trim())
                  .filter((x) => x)
              : undefined,
        }
      );
      console.log({ feedbackQuestion });
      toast.success("Question created successfully");

      setLoading(false);
      onClose(); // Close modal after submit
      if (onSuccess) onSuccess(feedbackQuestion);
    } catch (e) {
      setError(e.message);
      setLoading(false);
      toast.error("Error: " + e.message);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Question"
      showFooter={false}
      closeOnOutsideClick={false}
    >
      <div className="form-step">
        <label>District</label>
        <input type="text" value={user.district.name} disabled />

        <label>Office Category</label>
        <AutoCompleteDropdownStatic
          options={[
            {
              items: officeCategories?.map((x) => ({
                value: x._id,
                label: x.name,
              })),
            },
          ]}
          loading={!officeCategories}
          placeholder="Select Office Category"
          value={formData.officeCategory || ""}
          onSelect={(value) => handleChange("officeCategory", value)}
        />

        <label>Office Type</label>
        <AutoCompleteDropdownStatic
          options={[
            {
              items: officeTypes
                ?.filter((x) => x.category === formData.officeCategory)
                ?.map((x) => ({
                  value: x._id,
                  label: x.name,
                })),
            },
          ]}
          loading={!officeCategories}
          placeholder="Select Office Type"
          value={formData.officeType || ""}
          onSelect={(value) => handleChange("officeType", value)}
        />

        <label>Question</label>
        <input
          type="text"
          placeholder="Enter The Question"
          value={formData.question || ""}
          onChange={(e) => handleChange("question", e.target.value)}
        />

        <label>Answer Type</label>
        <AutoCompleteDropdownStatic
          options={[
            {
              items: config.feedbackQuestionTypes,
            },
          ]}
          placeholder="Select Response Type"
          value={formData.responseType || ""}
          onSelect={(value) => handleChange("responseType", value)}
        />

        {formData.responseType === "options" && (
          <>
            <label>
              Options <span>(Comma Separated)</span>
            </label>
            <input
              placeholder="Example: Yes, No, Maybe"
              value={formData.options || ""}
              onChange={(e) => handleChange("options", e.target.value)}
            ></input>
          </>
        )}
      </div>

      <div className="modal-footer">
        <button className="cancel-btn" onClick={onClose}>
          Cancel
        </button>
        {formData.officeType && formData.question && formData.responseType && (
          <button className="submit-btn" onClick={handleSubmit}>
            {loading ? "Loading.." : "Submit"}
          </button>
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  locationData: state.vState.APP.locationData,
  officeTypes: state.vState.APP.officeTypes,
  officeCategories: state.vState.APP.officeCategories,
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (
    obj,
    persist = false,
    screenName = "FEEDBACK_QUESTIONS_SCREEN"
  ) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewFeedbackQuestionForm);
